<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"\n"' class="col-lg-6 col-sm-12 m-0 p-0 mx-auto mb-2" >
                <template #default>   <m-video v-bind='{...{"controls":false,"videoSrc":"https:\/\/api.geramyan.com\/storage\/assets\/1 (2).mp4","autoplay":true,"muted":true,"loop":true,"poster":null},...{}}' :style='"object-fit: cover;\nborder-radius: 25px;\n\n\n"' class="col-lg-12 m-0 p-0  shadow" ></m-video></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container  pt-3 mb-4" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"\n"' class="col-lg-6 col-sm-12 m-0 p-0 mx-auto mb-2" >
                <template #default>   </template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12  col-md-6 p-4\np-4 text-center" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>بارگیری    </template>
                </m-h1><m-p v-bind='{...{},...{}}' :style='"    font-size: 16px;"' class="my-3" >
                <template #default>اعلام بار سراسری


 از فیلترهابرای پیدا کردن نام ماشین و غیره استفاده کنید

اگر بار برای ارسال دارید در قسمت ثبت آگهی _صاحب بار وارد شوید

بعد از ثبت آگهی برای صحت نوشته های خود وارد لیست آگهی خود شوید

تا در صورت نیاز به ویرایش تغییرات را انجام دهید
   </template>
                </m-p></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"background:#A6B0A6;\nborder-radius:25px;\nmargin-bottom:90px;\n"' class="container raounded " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.geramyan.com\/storage\/icons\/155-1554610_flavoryt-logo-app-store-icon-google-play-icon.png","alt":""},...{}}' :style='"border-radius:35px;\npadding:15px;"' class="col-lg-12" ></m-img></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 text-center mt-3" >
                <template #default>   <m-p v-bind='{...{},...{}}' :style='""' class="pt-4" >
                <template #default>برای دانلود نسخه اندروید برنامه "بارگیری" روی دکمه پایین فشار دهید   </template>
                </m-p><m-div v-bind='{...{},...{}}' :style='""' class="text-center m-2" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/api.geramyan.com\/storage\/icons\/app-release.apk","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-button v-bind='{...{},...{}}' :style='""' class="bg-primary " >
                <template #default>دانلود   </template>
                </m-button></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mVideo from '@moeinmdn/miw-alpha-components/src/package/Tags/Video'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mButton from '@moeinmdn/miw-alpha-components/src/package/Tags/Button';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mVideo,mH1,mP,mImg,mA,mButton },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
